import React, { useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import { inject, observer } from "mobx-react";
import { IComponentCommentList } from "../../component.d";
import { ThemeContext } from "../../store/ThemeProvider";
import intl from "react-intl-universal";
import { alpha, getPendantColor } from "../../utils/color";
import { IComment, ICommentType, ICommentListTheme } from "./AllForCommentList";
import ThemeList from "./ThemeList";
import ReactSVG from "react-svg";
import classNames from "classnames";
import { isIphoneX, getPageSameType } from "../../utils/util";
import { IComponentCommentSend } from "../../component.d";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import "../Switch/DanSwitch.css";
import "../Comment/SendMessage.scss";
import { isFullScreen } from "../../utils/dom";
import { formatCommentNumber } from "../../utils/util";
import ThemeFixedPopupComment from "./ThemeFixedPopupComment";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";
import {PageContext} from "../ComponentNavigatorV2/PageContext";
import usePortalDom from "../hooks/usePortalDom";

const ThemeFixed = (props: ICommentListTheme) => {
  const { rootStore, total, onLoadMore, newuser } = props;
  const [expand, setExpand] = useState(false);

  // const { on, setSwitch } = props;
  const [on, setSwitch] = useState(true);
  const { mainColor, h1Color, backgroundColor, componentColor } =
    useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [realBottom, setRealBottom] = useState(0);

  useEffect(() => {
    let { template } = window.pageDetail;
    let paddingBottom = 0;
    paddingBottom += isIphoneX() ? 22 : 0;
    let shouldBorder = false;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
      shouldBorder = true;
    }
    const commentsend = getPageSameType(
      template,
      [],
      ["commentsend"]
    ) as IComponentCommentSend[];
    if (commentsend && commentsend.length && expand) {
      // 没想到更合适的方法，找到0号元素，取他的数据，进行赋值
      const { paddingTop: top, paddingBottom: bottom } =
        commentsend[0].container;
      paddingBottom += 36 + (top ? +top : 0) + (bottom ? +bottom : 0);

      // if (
      //   commentsend[0] &&
      //   Number((commentsend[0] as IComponentCommentSend).emotion)
      // ) {
      //   paddingBottom += 73;
      //   shouldBorder = true;
      // }
    }

    // if(shouldBorder) {
    //   paddingBottom += 15;
    // }

    setRealBottom(paddingBottom - 5);
  }, [expand]);

  const [lastTotal, setLastTotal] = useState(-1);

  const [unread, setUnread] = useState(0);

  // 如果当前悬浮列表为展开状态，则显示评论，否则隐藏评论
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(
        new Event(
          !!expand ? "custom-commentsend-show" : "custom-commentsend-hide"
        )
      );
    }, 160);
  }, [expand]);

  useEffect(() => {
    if (lastTotal <= 0) {
      setLastTotal(total);
    } else if (lastTotal > 0 && total && lastTotal != total) {
      setUnread(Math.max(0, total - lastTotal));
    }
  }, [lastTotal, total]);

  const context = useContext(PageContext);
  const bottomWrapper = usePortalDom({
    parentElement:window.document.getElementById(`page-bottom-${context.cid}`)! as HTMLDivElement
  })

  return bottomWrapper ? createPortal(
    <div
      className="commentlist theme-fixed"
      style={{ pointerEvents: expand ? 'auto' : 'none' }}
    >
      {expand ? (
        <div
          className="theme-fixed-wrapper"
          style={{ background: alpha(componentColor, 1) }}
          onScroll={(e: any) => {
            if (e && e.currentTarget) {
              let target = e.currentTarget;
              if (onLoadMore) {
                onLoadMore(
                  target.clientHeight,
                  target.scrollHeight,
                  target.scrollTop
                );
              }
            }
          }}
        >
          <ThemeList
            {...props}
            headerExtra={
              <ReactSVG
                src={require("../../svg/x.svg")}
                className="x"
                style={{ fill: alpha(h1Color, 0.5) }}
                onClick={() => {
                  setExpand(false);
                  clearAllBodyScrollLocks();

                  setUnread(0);
                  setLastTotal(total);
                }}
              />
            }
          />
        </div>
      ) : (
        <div className="theme-fixed-icons">
          <ThemeFixedPopupComment enable={!expand && on} newuser={newuser} />
          <div
            className="dan-switch ignore-move"
            onClick={() => {
              setSwitch(!on);
            }}
          >
            <ReactSVG
              src={
                on
                  ? require("../../svg/dan.svg")
                  : require("../../svg/dan-off.svg")
              }
              style={{
                color: pendantIconColor,
                backgroundColor: pendantBgColor,
              }}
              className={classNames("dan-switch-svg", { on })}
            />
          </div>
          <div className="send-message-wrapper">
            <ReactSVG
              src={require("../../svg/icon-message.svg")}
              className={"ignore-move send-message-svg"}
              style={{
                backgroundColor: pendantBgColor,
                color: pendantIconColor,
              }}
              onClick={() => {
                let finalExpand = !expand;
                setExpand(finalExpand);
                // @ts-ignore
                // disableBodyScroll(document.body);
              }}
            />
            {!!total && (
              <div className="number number-animation" key={total}>
                <div className="real-number">
                  {formatCommentNumber(Number(total))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>,
    bottomWrapper
  ) : null;
};

export default ThemeFixed;
